/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Modal, Button } from "semantic-ui-react";
import { selectEditMode } from "../slices/editMode/editModeSlice";
import { resourceUpdated } from "../slices/resourceCollection/resourceCollectionSlice";
import ArrayEntry from "../datatypeComponents/ArrayEntry";
/*
const ageRangeValueSet = [ //Age
    {
        "coding": [{ system: "https://www.nlm.nih.gov/mesh", code: "D007223", display: "Infant" }]
    },
    {
        "coding": [
            { system: "https://www.nlm.nih.gov/mesh", code: "D002648", display: "Child" }]
    },
    {
        "coding": [
            { system: "https://www.nlm.nih.gov/mesh", code: "D000293", display: "Adolescent" }]
    },
    {
        "coding": [
            { system: "https://www.nlm.nih.gov/mesh", code: "D000328", display: "Adult" }]
    },
    {
        "coding": [
            {
                "system": "https://fevir.net/resources/CodeSystem/419455",
                "code": "includes-ages-in-utero",
                "display": "Includes ages in utero"
            }
        ],
        "text": "In Utero"
    },
    {
        "coding": [
            {
                "system": "https://fevir.net/resources/CodeSystem/419455",
                "code": "includes-ages-0-17",
                "display": "Includes ages 0-17 years"
            }
        ],
        "text": "0-17 years"
    },
    {
        "coding": [
            {
                "system": "https://fevir.net/resources/CodeSystem/419455",
                "code": "includes-ages-18-64",
                "display": "Includes ages 18-64 years"
            }
        ],
        "text": "18-64 years"
    },
    {
        "coding": [
            {
                "system": "https://fevir.net/resources/CodeSystem/419455",
                "code": "includes-ages-65-and-older",
                "display": "Includes ages 65 and older"
            }
        ],
        "text": "65+ years"
    },
    {
        "coding": [
            {
                "system": "https://fevir.net/resources/CodeSystem/419455",
                "code": "includes-preterm-newborns",
                "display": "Includes preterm newborns"
            }
        ],
        "text": "preterm newborn (up to gestational age < 37 weeks)"
    },
    {
        "coding": [
            {
                "system": "https://fevir.net/resources/CodeSystem/419455",
                "code": "includes-neonates",
                "display": "Includes neonates"
            }
        ],
        "text": "0-27 days"
    },
    {
        "coding": [
            {
                "system": "https://fevir.net/resources/CodeSystem/419455",
                "code": "includes-ages-28-day-23-month",
                "display": "Includes ages 28 days to 23 months"
            }
        ],
        "text": "28 days - 23 months"
    },
    {
        "coding": [
            {
                "system": "https://fevir.net/resources/CodeSystem/419455",
                "code": "includes-ages-2-5",
                "display": "Includes ages 2-5 years"
            }
        ],
        "text": "2-5 years"
    },
    {
        "coding": [
            {
                "system": "https://fevir.net/resources/CodeSystem/419455",
                "code": "includes-ages-6-11",
                "display": "Includes ages 6-11 years"
            }
        ],
        "text": "6-11 years"
    },
    {
        "coding": [
            {
                "system": "https://fevir.net/resources/CodeSystem/419455",
                "code": "includes-ages-12-17",
                "display": "Includes ages 12-17 years"
            }
        ],
        "text": "12-17 years"
    },
    {
        "coding": [
            {
                "system": "https://fevir.net/resources/CodeSystem/419455",
                "code": "includes-ages-65-84",
                "display": "Includes ages 65-84 years"
            }
        ],
        "text": "65-84 years"
    },
    {
        "coding": [
            {
                "system": "https://fevir.net/resources/CodeSystem/419455",
                "code": "includes-ages-85-and-older",
                "display": "Includes ages 85 and older"
            }
        ],
        "text": "85+ yrs"
    },
    {
        "coding": [
            {
                "system": "https://fevir.net/resources/CodeSystem/419455",
                "code": "includes-ages-18-64",
                "display": "Includes ages 18-64 years"
            }
        ],
        "text": "18-64 years"
    }
]

const genderValueSet = [//Biological sex
    {
        "coding": [{ system: "http://snomed.info/sct", code: "248153007", display: "Male (finding)" }]
    },
    {
        "coding": [{ system: "http://snomed.info/sct", code: "248152002", display: "Female (finding)" }]
    },
    {
        "coding": [{ system: "http://snomed.info/sct", code: "32570681000036106", display: "Indeterminate sex (finding)" }]
    },
    {
        "coding": [{ system: "http://snomed.info/sct", code: "32570691000036108", display: "Intersex (finding)" }]
    }
];
*/
const systemChoices = [
    { "uri": "http://snomed.info/sct", "display": "SNOMED-CT" },
    { "uri": "http://loinc.org", "display": "LOINC" },
    { "uri": "http://www.nlm.nih.gov/research/umls/rxnorm", "display": "RxNorm" },
    { 'uri': 'http://hl7.org/fhir/sid/icd-10', 'display': 'ICD-10' },
    { 'uri': 'http://id.who.int/icd/release/11/mms', 'display': 'ICD-11' },
    { 'uri': 'http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl', 'display': 'NCIT' },
    { 'uri': 'http://www.whocc.no/atc', 'display': 'ATC' },
    { 'uri': 'http://fdasis.nlm.nih.gov', 'display': 'UNII' },
    { 'uri': 'https://www.nlm.nih.gov/mesh', 'display': 'MeSH' }
];

const submitPicoClassifierChanges = (dispatch, setPicoClassifierModalState,
    picoClassifiersState, parentResourceDetail, resourceType) => {
    let newClassification = picoClassifiersState.nonPicoArray;
    if (picoClassifiersState.populationArray.length > 0) {
        newClassification.push({
            "type": {
                "coding": [
                    {
                        "system": "https://fevir.net/resources/CodeSystem/179423",
                        "code": "population",
                        "display": "Population"
                    }
                ]
            },
            "classifier": picoClassifiersState.populationArray
        });
    }
    if (picoClassifiersState.interventionArray.length > 0) {
        newClassification.push({
            "type": {
                "coding": [
                    {
                        "system": "https://fevir.net/resources/CodeSystem/179423",
                        "code": "intervention",
                        "display": "Intervention"
                    }
                ]
            },
            "classifier": picoClassifiersState.interventionArray
        });
    }
    if (picoClassifiersState.comparatorArray.length > 0) {
        newClassification.push({
            "type": {
                "coding": [
                    {
                        "system": "https://fevir.net/resources/CodeSystem/179423",
                        "code": "comparator",
                        "display": "Comparator"
                    }
                ]
            },
            "classifier": picoClassifiersState.comparatorArray
        });
    }
    if (picoClassifiersState.outcomeArray.length > 0) {
        newClassification.push({
            "type": {
                "coding": [
                    {
                        "system": "https://fevir.net/resources/CodeSystem/179423",
                        "code": "outcome-measure",
                        "display": "Outcome Measure"
                    }
                ]
            },
            "classifier": picoClassifiersState.outcomeArray
        });
    }
    if (newClassification.length > 0) {
        console.log("resourceUpdate for Resource.classification");
        let newProfile = "";
        if (resourceType === "Evidence") {
            newProfile = "http://hl7.org/fhir/uv/ebm/StructureDefinition/pico-tagged-evidence";
        }
        if (resourceType === "Composition") {
            newProfile = "http://hl7.org/fhir/uv/ebm/StructureDefinition/pico-tagged-composition";
        }
        let newResourceDetail = JSON.parse(JSON.stringify(parentResourceDetail));
        newResourceDetail.revisedResourceJson["classification"] = newClassification;
        if (newProfile) {
            if (newResourceDetail.revisedResourceJson.meta) {
                if (newResourceDetail.revisedResourceJson.meta.profile) {
                    if (!newResourceDetail.revisedResourceJson.meta.profile.includes(newProfile)) {
                        newResourceDetail.revisedResourceJson.meta.profile.push(newProfile);
                    }
                } else {
                    newResourceDetail.revisedResourceJson.meta["profile"] = [newProfile];
                }
            } else {
                newResourceDetail.revisedResourceJson["meta"] = { "profile": [newProfile] };
            }
        }
        dispatch(resourceUpdated(newResourceDetail));
    } else {
        alert("No changes applied. No classification values provided.");
    }
    setPicoClassifierModalState(prevState => { return { ...prevState, modalOpen: false }; });
}

const PicoClassifierModal = ({ setPicoClassifierModalState, parentResourceDetail }) => {
    const dispatch = useDispatch();
    const editMode = useSelector(selectEditMode);

    const newResourceJson = parentResourceDetail?.revisedResourceJson;
    const resourceType = newResourceJson?.resourceType;

    const [picoClassifiersState, setPicoClassifiersState] = useState({});
    const [containedResourceDictionary, setContainedResourceDictionary] = useState({});

    useEffect(() => {
        if (newResourceJson) {
            let populationArray = [];
            let interventionArray = [];
            let comparatorArray = [];
            let outcomeArray = [];
            let nonPicoArray = [];
            let classification = newResourceJson.classification || [];
            if (classification.length > 0) {
                for (const item of classification) {
                    const code = item?.type?.coding?.[0]?.code;
                    if (code === "population" && item.classifier) {
                        populationArray = item.classifier;
                    }
                    else if (code === "intervention" && item.classifier) {
                        interventionArray = item.classifier;
                    }
                    else if (code === "comparator" && item.classifier) {
                        comparatorArray = item.classifier;
                    }
                    else if (code === "outcome-measure" && item.classifier) {
                        outcomeArray = item.classifier;
                    }
                    else {
                        nonPicoArray.push(item);
                    }
                }
            }
            setPicoClassifiersState({
                populationArray: populationArray,
                interventionArray: interventionArray,
                comparatorArray: comparatorArray,
                outcomeArray: outcomeArray,
                nonPicoArray: nonPicoArray
            });
            if (Array.isArray(newResourceJson.contained) && newResourceJson.contained.length > 0) {
                let containedResourceDictionary = {};
                for (const item of newResourceJson.contained) {
                    const key = "#" + item.id;
                    containedResourceDictionary[key] = item;
                }
                setContainedResourceDictionary(containedResourceDictionary);
            }
        }
    }, []);

    const modalContent = <>
        <Modal.Content style={{ paddingTop: "4px", textAlign: "center" }}>
            {(editMode && newResourceJson && parentResourceDetail) &&
                <Button style={{ padding: "6px", position: "absolute", left: "6px", top: "2px" }}
                    className="formButton positive"
                    content="Submit Changes"
                    onClick={() => {
                        submitPicoClassifierChanges(dispatch, setPicoClassifierModalState,
                            picoClassifiersState, parentResourceDetail, resourceType);
                    }} />
            }
            <Button style={{ padding: "6px", position: "absolute", right: "6px", top: "2px" }}
                className="formButton negative"
                content="✖"
                onClick={() => {
                    setPicoClassifierModalState(prevState => { return { ...prevState, modalOpen: false }; });
                }} />
            {(picoClassifiersState && Object.keys(picoClassifiersState).length > 0) &&
                <div style={{ marginTop: "4px", textAlign: "left" }}>
                    <br />
                    <h3>Classify the Population</h3>
                    <ArrayEntry datatype="CodeableReference"
                        containedResourceDictionary={containedResourceDictionary}
                        elementName='populationArray'
                        systemChoices={systemChoices} systemChoicesOpen={true}
                        fieldLabel='Condition' startCollapsed={true} startEmptyArrayClosed={true}
                        startingValue={picoClassifiersState.populationArray || []}
                        setResourceState={setPicoClassifiersState} />
                    <h3>Classify the Intervention</h3>
                    <ArrayEntry datatype="CodeableReference"
                        containedResourceDictionary={containedResourceDictionary}
                        elementName='interventionArray'
                        systemChoices={systemChoices} systemChoicesOpen={true}
                        fieldLabel='Intervention' startCollapsed={true} startEmptyArrayClosed={true}
                        startingValue={picoClassifiersState.interventionArray || []}
                        setResourceState={setPicoClassifiersState} />
                    <h3>Classify the Comparator</h3>
                    <ArrayEntry datatype="CodeableReference"
                        containedResourceDictionary={containedResourceDictionary}
                        elementName='comparatorArray'
                        systemChoices={systemChoices} systemChoicesOpen={true}
                        fieldLabel='Comparator' startCollapsed={true} startEmptyArrayClosed={true}
                        startingValue={picoClassifiersState.comparatorArray || []}
                        setResourceState={setPicoClassifiersState} />
                    <h3>Classify the Outcome(s)</h3>
                    <ArrayEntry datatype="CodeableReference"
                        containedResourceDictionary={containedResourceDictionary}
                        elementName='outcomeArray'
                        systemChoices={systemChoices} systemChoicesOpen={true}
                        fieldLabel='Outcome' startCollapsed={true} startEmptyArrayClosed={true}
                        startingValue={picoClassifiersState.outcomeArray || []}
                        setResourceState={setPicoClassifiersState} />
                </div>
            }
        </Modal.Content>
    </>

    return <>
        <Modal
            style={{ padding: "0px", margin: "0px", width: "85%", maxHeight: "96vh", overflowY: "auto" }}
            dimmer={<Modal.Dimmer style={{ backgroundColor: "#00000077" }} />}
            open={true}
            centered={false}
            content={modalContent}
        />
    </>
};

export default PicoClassifierModal;
export { systemChoices };